<template>
  <Menu as="div" class="helper" v-if="parent">
    <div>
      <MenuButton class="dropdown-icon">
        <span class="sr-only">
          Assistent öffnen
        </span>
        <span class="inline-block w-16 h-16 rounded-full overflow-hidden bg-gray-100">
          <img src="/images/assistant.svg" />
        </span>
      </MenuButton>
    </div>
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <MenuItems class="dropdown-items">
        <MenuItem v-for="assistance in records" :key="assistance.id" v-slot="{ active }">
            <router-link :to="{name: 'assistances.show', params: {id: assistance.id}}" class="dropdown-item">
              <div class="flex items-center">
                <ChatBubbleOvalLeftIcon class="h-6 w-6 mr-2 text-gray-500" />
                <span>
                  {{ assistance.subject }}
                </span>
              </div>
            </router-link>
        </MenuItem>
        <hr v-if="!empty" />
        <MenuItem v-slot="{ active }">
          <router-link :to="{name: 'assistances.list'}" class="dropdown-item">
            Alle Tipps anzeigen
          </router-link>
        </MenuItem>
        <MenuItem v-slot="{ active }">
          <router-link :to="{name: 'feedback'}" class="dropdown-item">
            Feedback geben
          </router-link>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup>
import { computed, onMounted, onUnmounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useFetchResources } from '@/client/actions';

const props = defineProps({context: String});
const store = useStore();

const parent = computed(() => props.context);
const target = computed(() => '/api/podcasts/' + parent.value + '/assistances');
const records = computed(() => results.value.slice(0,5));
const action = useFetchResources(target);

const { results, fetch, empty } = action;

const enable = () => setInterval(fetch, 10000);
const disable = (t) => clearInterval(t);

const timer = enable();
const watcher = watch(parent, fetch);

onMounted(() => fetch());
onUnmounted(() => disable(timer));
</script>

<style scoped>
.helper
{
  @apply fixed bottom-10 right-8;
  @apply flex justify-center items-center;
  @apply rounded-full drop-shadow-lg;
}

.dropdown-items
{
  @apply absolute right-0 bottom-24 z-10 mb-2 w-96;
  @apply origin-bottom;
  @apply rounded-md bg-white py-1 shadow-md;
  @apply ring-1 ring-black ring-opacity-5;
  @apply focus:outline-none
}

.dropdown-item
{
  @apply block px-4 py-2;
  @apply text-sm text-gray-700;
  @apply cursor-pointer;
}
</style>

